export default function genererCampagne(societeId) {
  return {
    libelle: '',
    libelleInterne: '',
    marqueId: null,
    tags: [],
    actif: true,
    dateDebut: null,
    dateFin: null,
    societeId: societeId,
    newsLetter: false,
    visibleParLaMarque: true,
  };
}
